import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { Observable } from "rxjs";

interface WorkDetails {
  show?: unknown;
  Categories?: unknown[];
  [key: string]: unknown;
}

@Injectable({
  providedIn: "root",
})
export class HireService {
  private http = inject(HttpClient);
  toastController = inject(ToastController);


  newWork(_data: Record<string, unknown>) {
    // intencionalmente vazio: placeholder mantido por compatibilidade de API
  }

  findAll() {
    const url = environment.api.baseUrl + environment.api.endpoints.my_hires;
    return this.http
      .get(url)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  /**
   * Versão paginada (backend novo): GET my/hires/?page=N devolve
   * {count, next, previous, results} com itens já enriquecidos (specialities,
   * is_show, is_bilheteria...). Backend antigo ignora o parâmetro e devolve a
   * lista legada — quem chama deve tratar os dois formatos.
   */
  findAllPage(page: number, pageSize: number = 10) {
    const url =
      environment.api.baseUrl +
      environment.api.endpoints.my_hires +
      `?page=${page}&page_size=${pageSize}`;
    return this.http
      .get(url)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  getMyHires(): Promise<unknown[]> {
    const url = environment.api.baseUrl + environment.api.endpoints.my_hires;
    return this.http
      .get<unknown[]>(url)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  getMyWorks(): Promise<unknown[]> {
    const url = environment.api.baseUrl + environment.api.endpoints.my_works;
    return this.http
      .get<unknown[]>(url)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  getById(id: string): Observable<WorkDetails> {
    const url =
      environment.api.baseUrl + environment.api.endpoints.hire_by_id + id + "/";
    return this.http.get<WorkDetails>(url);
  }

  contract(id, hire: Record<string, unknown>) {
    const url =
      environment.api.baseUrl +
      environment.api.endpoints.finally_hire +
      id +
      "/";
    return this.http
      .post(url, hire)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  finally(idWork, body) {
    const url =
      environment.api.baseUrl +
      environment.api.endpoints.contract_no_offer +
      idWork +
      "/";
    return this.http
      .post(url, body)
      .toPromise()
      .catch(function (error) {
        throw error;
      });
  }

  accept(idWork, body) {
    const url = environment.api.baseUrl + environment.api.endpoints.api_offers + idWork + "/";
    return this.http.put(url, body);
  }
}